import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Contract } from '../models/contract';
import { Observable } from 'rxjs';
import { ContractComment } from '../models/contractComment';
import { ContractSmall } from '../models/contract-small';
import { ContractCurrency } from '../models/contract-currency';


@Injectable({
  providedIn: 'root'
})
export class ContractApiService {
  private apiBaseUrl = `${environment.apiUrl}contract`;

  constructor(private httpClient: HttpClient) { };

  public getAllContracts() {
    return this.httpClient.get<Contract[]>(`${this.apiBaseUrl}/contractsOverview`);
  }

  public postContracts(contracts: Contract[]){
    return this.httpClient.post(this.apiBaseUrl + '/saveContracts', contracts);
  }

  public getProfileContract(profileId: number){
    return this.httpClient
    .get<Contract>(`${this.apiBaseUrl}/getProfileContract?profileId=${profileId}`)
  }

  public getContracts(profileId: number){
    return this.httpClient.get<ContractSmall[]>(`${this.apiBaseUrl}/getContracts/${profileId}`)
  }

  public post(contract: Contract){
    return this.httpClient.post(this.apiBaseUrl, contract);

  }

  public put(contract: Contract){
    return this.httpClient.put(this.apiBaseUrl, contract);
  }

  public getProfiles() {
    return this.httpClient.get<Contract[]>(`${this.apiBaseUrl}/getProfiles`);
  }

  public getProfilesOld() {
    return this.httpClient.get<Contract[]>(`${this.apiBaseUrl}/getProfilesOld`);
  }


  public getContractByContractId (contractId: number) {
    if (contractId == null || contractId == undefined) {
      contractId = 0;
    }
    return this.httpClient.get<Contract>(`${this.apiBaseUrl}/${contractId}`);
  }

  public deleteContract(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${this.apiBaseUrl}/${id}`);
  }

  public createContractComment(contractComment: ContractComment) {
      return this.httpClient.post(this.apiBaseUrl + '/createContractComment', contractComment);
  }

  public updateContractComment(contractComment: ContractComment) {
      return this.httpClient.patch(this.apiBaseUrl + '/updateContractComment', contractComment);
  }

   public getAllContractCommentsByContractId(contractId: number) {
    return this.httpClient.get<ContractComment[]>(`${this.apiBaseUrl}/getCommentsByContractId/${contractId}`)
  }

   public deleteContractComment(commentId: number) {
    return this.httpClient.delete<number>(`${this.apiBaseUrl}/deleteComment/${commentId}`);
  }

  public getContractsByProfileAndCustomer(profileId: number, customerId: number) {
    return this.httpClient.get<ContractSmall[]>(`${this.apiBaseUrl}/contracts/profile/${profileId}/customer/${customerId}`)
  }

  public getContractCurrency(contractId: number) {
    return this.httpClient.get<ContractCurrency | null>(`${this.apiBaseUrl}/${contractId}/currency`);
  }

}